<template>
  <div class="wrp">
    <div class="top clear">
      <h1>POS Brand</h1>
    </div>
    <div class="btn-pos clear">
      <button class="light" @click="add">Add POS Brand</button>
    </div>
    <div class="table-wrp pos" style="min-width:890px">
      <el-table
          :data="tableData2"
          style="width: 100%">
        <el-table-column
          label="POS Brand"
          prop="posBrand">
        </el-table-column>
        <el-table-column
          label="Does it support Doshii ?"
          prop="venueMobile">
          <template slot-scope="scope">
            <div v-if="scope.row.posIsSupport === 1">Yes</div>
            <div v-else style="color:#EA3796">No</div>
          </template>
        </el-table-column>
        <el-table-column
          label="Operation">
          <template slot-scope="scope">
            <div class="btns clear">
              <button class="light" @click="edit(scope.row)">Edit</button>
              <button class="dark" @click="remove(scope.row.posId)">Remove</button>
            </div>
          </template>
        </el-table-column>
        <template slot="empty">
            <i v-if="loading" class="el-icon-loading" style="font-size:20px"></i>
            <div v-else>-</div>
        </template>
      </el-table>
      <div class="ros_footerPage">
        <el-pagination
            v-if="!loading"
            class="my_pageSel"
            layout="prev, pager, next"
            @current-change="pageChange"
            :page-size="10"
            :current-page.sync="page"
            :total="totalRecord">
        </el-pagination>
    </div>
    </div>

    <el-dialog
      title="You sure you want to Remove it?"
      :visible.sync="delposDio"
      :modal-append-to-body="false"
      :show-close="false"
      class="delsmsDio_box"
      :close-on-click-modal="false"
      width="740px"
      center>
          <div class="foot_box">
              <el-button @click="cancel" class="cardCanBtn">Cancel</el-button>
              <el-button @click="delpos" class="cardConBtn">Confirm</el-button>
          </div>
    </el-dialog>

  </div>
</template>

<script>
import api from '../../api/pos'

export default {
  data () {
    return {
      tableData2: [],
      loading: true, // 是否正在加载
      exportDisable: true, // 导出按钮是否不可用
      totalRecord: 0,
      page: 1,
      pagesize: 10,
      delposDio: false,
      id: null,
      deleting: false,
    }
  },
  /*created () {
    this.getList()
  },*/
  methods: {
    cancel () {
      var that = this
      if (that.deleting)
        return
      that.delposDio=false
    },
    delpos(){
      var that = this
      if (that.deleting)
        return
      api.delPos({
        params: that.id, 
        callback: (res) => {
          that.delposDio = false
          that.deleting = false
          that.id = null
          if(res.data.code == 0){
            that.getList()
          } else {
            Utils.alert('', res.data.message, 'error')
          }
        }
      })
    },
    remove (id) {
      var that = this
      that.delposDio = true
      that.id = id
    },
    // 新增venue
    add () {
      this.$router.push('/posadd')
    },
    edit (row) {
      sessionStorage.setItem('posRow', JSON.stringify(row))
      this.$router.push(`/posedit/${row.posId}`)
    },
    pageChange (page) {
      this.page = page
      this.getList()
    },
    lstCallback (res) {
      var that = this
      if(res.data.code == 0){
        // 等待接口
        if (this.page !== 1 && res.data.data.list.length === 0) {
          this.page -- 
          this.getList()
        } else {
          that.loading = false
          this.tableData2 = res.data.data.list
          this.totalRecord = res.data.data.total
        }
      } else{
        that.loading = false
        Utils.alert('', res.data.message, 'error')
      }
    },
    getList() {
      api.getLst({
        params: {
          pageNum: this.page,
          pageSize: this.pagesize
        }, 
        callback: this.lstCallback
      })
    }
  },
  activated() {
    if(!this.$route.meta.isUseCache){ //isUseCache 时添加中router中的元信息，判读是否要缓存
      this.page = 1
      this.getList() // 重新加载
    }
  }
}
</script>

<style lang="scss" scoped>
.ros_footerPage{
    display: flex;
    justify-content: center;
}
.wrp{
  color: #fff;
  padding-bottom: 50px;
  .top{
    width: 100%;
    margin-bottom: 39px;
    h1{
      font-size: 24px;
      font-weight: 600;
      float: left;
      margin-right: 50px;
      font-family: 'PingFangSC-Semibold';
    }
  }
  .btns, .btn-pos{
    width: 100%;
    margin-bottom: 30px;
    button{
      outline: none;
      border: none;
      height: 60px;
      font-family: 'PingFangSC-Semibold';
      font-size: 26px;
      background-color: transparent;
    }
    .light{
      width: 280px;
      border: 1px solid #EA3796;
      margin-right: 30px;
      color: #EA3796;
      cursor: pointer;
    }
    .dark{
      border: 1px solid #FFFFFF;
      color: #FFFFFF;
      width: 200px;
      cursor: pointer;
    }
    .disable{
      border: 1px solid gray;
      color: gray;
      cursor: not-allowed;
    }
  }
  .btns{
    text-align: right;
  }
  .btn-pos{
    text-align: left;
  }
  .table-wrp{
    .btns{
      margin-bottom: 0;
    }
    button{
      height: 40px;
      font-size: 18px;
    }
    .light{
      width: 100px;
      margin-right: 10px;
    }
    .dark{
      width: 100px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pos/index.vue